<template>
  <div
    class="ui-subtitle"
    :class="{
      'ui-subtitle--large': large,
      'ui-subtitle--default': !large && !small,
      'ui-subtitle--small': small,
      'ui-subtitle--centered': centered,
    }"
  >
    <slot><span v-dompurify-html="purifyAndAllowHtmlTags(subtitle)" /></slot>
  </div>
</template>

<script>
import { purifyAndAllowHtmlTags } from '@/utils/purifyString.util'

export default {
  name: 'UiSubtitle',
  props: {
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    centered: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      purifyAndAllowHtmlTags,
    }
  },
}
</script>

<style lang="scss" scoped>
.ui-subtitle {
  @apply tw-text-gray-500 dark:tw-text-gray-400;

  &--large {
    @apply tw-text-base;
  }

  &--default {
    @apply tw-text-sm;
  }

  &--small {
    @apply tw-text-xs;
  }

  &--centered {
    @apply tw-text-center;
  }
}
</style>
